import { isGanglionMessage, type GanglionConversationResponse } from "../../pages/chat/messagetypes";

export enum StreamingState {
    None,
    QuestionSent,
    QuestionAcknowledged,
    AnswerArriving,
}

export class StreamingStateMachine {
    private _expectedReponseTimeout: ReturnType<typeof setTimeout> | null = null;
    private _state: StreamingState = StreamingState.None;
    private _statusCallback: (() => void)|null = null;

    constructor(opts?: {
        onStatus: () => void,
    })
    {
        this._statusCallback = opts?.onStatus ?? null;
    }

    get state() {
        return this._state;
    }

    reset() {
        this._setTimer();
        this._state = StreamingState.None;
    }

    onMessageSent() {
        this._setTimer(6000);
        this._state = StreamingState.QuestionSent;
    }

    onMessageReceived(msg: GanglionConversationResponse) {
        if (!isGanglionMessage(msg)) return;
        // todo: also verify if its the the expected kind of message
        this._setTimer();

        if(msg.type == "message-end") {
            this.reset();
            return;
        }

        switch (this._state) {
            case StreamingState.None:
                // weird, we shouldn't be receiving anything now
                return;
            case StreamingState.QuestionSent:
                // todo: "msg-ack"

                this._state = StreamingState.QuestionAcknowledged;
                this._setTimer(2_000);

                // todo: count up, and emit warning to UI
                this._statusCallback?.();
                break;

            case StreamingState.QuestionAcknowledged:
                this._state = StreamingState.AnswerArriving;
                this._setTimer(10_000);

                // todo: count up, and emit warning to UI
                this._statusCallback?.();
                break;

            case StreamingState.AnswerArriving:
                // todo: count up, and emit warning to UI
                this._statusCallback?.();
                break;
        }
    }

    private _setTimer(timeout?: number) {
        if (this._expectedReponseTimeout) {
            clearTimeout(this._expectedReponseTimeout);
        }
        this._expectedReponseTimeout = timeout === undefined ? null : setTimeout(() => this._onMissingResponse(), timeout);
    }

    private _onMissingResponse() {
        // todo: find out which state we're in.  maybe it _expectResponse should set a state instead of expected types

        switch (this._state) {
            case StreamingState.None:
                // weird, we shouldn't be expecting anything now
                return;
            case StreamingState.QuestionSent:
                // backend never acknowledged the question.
                // this probably means something about the connection is completely broken.

                break;
            case StreamingState.QuestionAcknowledged:
                // answer isnt streaming in, perhaps there's a problem with the model provider.

                break;

            case StreamingState.AnswerArriving:
                break;
        }

        console.error("GanglionConnection didn't receive a message within the expected time.");
        this._expectedReponseTimeout = null;
    }
}
